<template>
  <div forgot-password>
    <Layout
      :app="app"
      header="Reset password"
      title="Reset your password"
    >
      <template v-slot:desc>
        Enter your new password
      </template>

      <ul
        v-if="errors"
        class="error"
      >
        <li
          v-for="err in errors"
          :key="err.message"
        >
          {{ err.message }}
        </li>
      </ul>

      <div
        v-if="completed"
        class="completed"
      >
        Password updated. <router-link
          class="link"
          :to="`/${appKey}/sign-in`"
        >
          Sign In here.
        </router-link>
      </div>
      <template v-else>
        <Input
          v-model="password"
          :autofocus="true"
          class="input"
          label="New password"
          type="password"
          placeholder="super secret"
          @enter="submit"
        />

        <Input
          v-model="confirmPassword"
          class="input"
          label="Confirm new password"
          type="password"
          placeholder="super secret"
          @enter="submit"
        />

        <div
          v-if="loading"
          class="loading"
        >
          <Spinner />
        </div>
        <Button
          v-else
          class="button"
          label="Reset"
          @click="submit"
        />
      </template>
    </Layout>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import Layout from './layout.vue';
  import Input from '../../components/input.vue';
  import Button from '../../components/button.vue';
  import Spinner from '../../components/spinner.vue';
  import app from '../../mixins/app';

  export default {
    name: 'ForgotPassword',
    components: {
      Layout,
      Input,
      Button,
      Spinner,
    },
    mixins: [app],
    data() {
      return {
        password: '',
        errors: null,
        confirmPassword: '',
        loading: false,
        completed: false,
      };
    },
    computed: {
      token() {
        return this.$route.params.token;
      },
    },
    methods: {
      submit() {
        if (!this.password) {
          this.errors = [{ message: 'Please enter a valid password' }];
          return;
        }
        if (this.password !== this.confirmPassword) {
          this.errors = [{ message: 'Password confirmation does not match' }];
          return;
        }
        this.errors = null;
        this.loading = true;
        this.$apollo.mutate({
          mutation: gql`mutation ($key: String!, $password: String!, $token: String!) {
          resetPassword (key: $key, password: $password, token: $token)
        }`,
          variables: {
            key: this.appKey,
            password: this.password,
            token: this.token,
          },
        }).then(() => {
          this.loading = false;
          this.completed = true;
        }).catch((error) => {
          this.loading = false;
          this.errors = error.graphQLErrors;
        });
      },
    },
  };
</script>

<style scoped lang="stylus">
  @require '~@/style/colors'
  @require '~@/style/type'

  .input
    margin-top: 30px
    &:first-of-type
      margin-top: 0

  .button, .loading
    width: 100%
    margin-top: 60px

  .loading
    height: 50px
    display: flex
    align-items: center
    justify-content: center

  .links
    @extend $type-small
    display: block
    width: 100%
    text-align: center
    margin-top: 30px
    a
      display: inline-block
      margin-left: 10px
      padding-right: 10px
      border-right: 1px solid #aaa
      &:last-of-type
        border-right: none

  .error
    @extend $type-small, $type-medium
    color: #a00
    background-color: rgba(205,92,92,.1)
    text-align: center
    list-style: none
    margin: 0 0 20px 0
    padding: 10px

  .completed
    @extend $type-small, $type-medium
    color: #060
    background-color: rgba(92,205,92,.1)
    text-align: center
    list-style: none
    margin: 0 0 20px 0
    padding: 10px
    .link
      color: #060
      text-decoration: underline


</style>
